module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content year month"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12"
  }, [_c('div', {
    staticClass: "titles"
  }, [_c('h2', {
    staticClass: "h-l"
  }, [_vm._v("learn")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_c('h1', {
    staticClass: "h-xl category"
  }, [_vm._v("600state")])]), _c('h3', {
    staticClass: "h-sm desc"
  }, [_vm._v(_vm._s(_vm.description))]), _vm._l((_vm.categories), function(cat) {
    return _c('router-link', {
      key: cat,
      attrs: {
        "to": _vm.categoryLink(cat)
      }
    }, [_c('h3', {
      staticClass: "h-sm cat",
      class: {
        active: _vm.catActive(cat)
      }
    }, [_vm._v(_vm._s(cat))])])
  })], 2)]), _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "grid no-margin"
  }, [(_vm.currentIndex === 0 && _vm.featuredActive === 'active') ? _c('div', {
    staticClass: "col-12_xs-12 featured"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'article',
        params: {
          category: _vm.getCat(_vm.featuredMain),
          article: _vm.featuredMain.uid
        }
      }
    }
  }, [_c('div', {
    staticClass: "screen-blog-featured"
  }, [(_vm.hero(_vm.featuredMain)) ? _c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.heroImage(_vm.featuredMain),
      "alt": _vm.heroCaption(_vm.featuredMain)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "captions"
  }, [_c('h2', {
    staticClass: "h-l lh-95 title",
    domProps: {
      "innerHTML": _vm._s(_vm.checkTitle(_vm.featuredMain))
    }
  }), (_vm.featuredMain.content.author.length > 0) ? _c('h2', {
    staticClass: "h-md author"
  }, [_vm._v(_vm._s(_vm.featuredMain.content.author) + " "), _c('br'), _vm._v("\n" + _vm._s(_vm.featuredMain.content.date))]) : _c('h2', {
    staticClass: "h-md author"
  }, [_vm._v(_vm._s(_vm.featuredMain.content.date))])])])])], 1) : _vm._e(), _vm._l((_vm.featured), function(post) {
    return (_vm.currentIndex === 0 && _vm.featuredActive === 'active') ? _c('div', {
      staticClass: "col-6_xs-12 featured"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            category: _vm.getCat(post),
            article: post.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "screen-small"
    }, [(_vm.hero(post)) ? _c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.heroImage(post),
        "alt": _vm.heroCaption(post)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "h-l lh-95 title",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(post))
      }
    }), (post.content.author.length > 0) ? _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.author) + " "), _c('br'), _vm._v("\n" + _vm._s(post.content.date))]) : _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.date))])])])])], 1) : _vm._e()
  }), _vm._l((_vm.posts), function(post) {
    return _c('div', {
      staticClass: "col-6_xs-12"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'article',
          params: {
            category: _vm.getCat(post),
            article: post.uid
          }
        }
      }
    }, [_c('div', {
      staticClass: "screen-small"
    }, [(_vm.hero(post)) ? _c('img', {
      staticClass: "cover",
      attrs: {
        "src": _vm.heroImage(post),
        "alt": _vm.heroCaption(post)
      }
    }) : _vm._e(), _c('div', {
      staticClass: "captions"
    }, [_c('h2', {
      staticClass: "h-l lh-95 title",
      domProps: {
        "innerHTML": _vm._s(_vm.checkTitle(post))
      }
    }), (post.content.author.length > 0) ? _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.author) + " "), _c('br'), _vm._v("\n" + _vm._s(post.content.date))]) : _c('h2', {
      staticClass: "h-md author"
    }, [_vm._v(_vm._s(post.content.date))])])])])], 1)
  })], 2)])]), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-3_xs-12"
  }), _c('div', {
    staticClass: "col-9_xs-12"
  }, [_c('div', {
    staticClass: "index"
  }, _vm._l((_vm.numPages), function(page) {
    return _c('p', {
      class: {
        active: _vm.active(page)
      },
      on: {
        "click": function($event) {
          _vm.loadPage(page)
        }
      }
    }, [_vm._v(_vm._s(page + 1))])
  }))])])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-327caa47"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog.vue
// module id = 232
// module chunks = 1